export default "__VITE_ASSET__pYSCEZS4__"